import { Col, Row } from 'reactstrap';
import React from 'react';
import 'features/pending-timesheets/styles/timesheet-comment.scss';

export interface ITimesheetCommentProps {
    timesheetComment: string;
    textAlign: string;
}

const TimesheetComment = (props: ITimesheetCommentProps): JSX.Element => {
    if (props.timesheetComment === null || props.timesheetComment === undefined || props.timesheetComment === '') {
        return null;
    }

    return (
        <>
            <Row className="w-100 font-weight-bold mb-1">
                <Col className={`timesheet-comment-border pt-2 ${props.textAlign}`}>Timesheet comment: </Col>
            </Row>
            <Row className={`w-100 font-weight-normal timesheet-comment mb-3 mt-0 ${props.textAlign}`}>
                <Col>{props.timesheetComment}</Col>
            </Row>
        </>
    );
};

export default TimesheetComment;
